
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import Partnership from '../../../../components/docs/plaidoms/Partnership';
export const metadata = {
  toc: true,
  layout: 'guide',
  maxTocLevel: 4,
  skipLLM: true,
  description: "Instantly authenticate your customers' bank accounts for use with Bond's ACH Transfers API"
};
export const partnerProps = {
  partner: 'Bond',
  clientLibrary: 'bond',
  subtitle: metadata.description,
  registrationUrl: 'https://www.bond.tech/contact',
  apiUrl: 'https://docs.bond.tech',
  isPaymentProcessor: true
};

const layoutProps = {
  metadata,
partnerProps
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Partnership.Header {...partnerProps} />
    <h4 {...{
      "id": "overview"
    }}>{`Overview`}</h4>
    <p>{`Plaid and Bond have partnered to provide Bond customers a seamless and secure way to link external bank accounts to Bond. With Bond's APIs, you can then connect the linked accounts to Bond customers or businesses and make ACH payments to and from those linked accounts.`}</p>
    <p>{`Plaid's SDKs make it easy to link account information across a variety of platforms. Bond provides a full suite of banking, credit, and compliance products that allows customers to onboard consumers and businesses, open deposit accounts, issue cards, and make payments in a unified API platform. Using this integration, you can leverage Plaid's multi-platform SDKs while leaving the nuances of validating, originating, and operating ACH payments to Bond.`}</p>
    <h4 {...{
      "id": "getting-started"
    }}>{`Getting Started`}</h4>
    <Partnership.GettingStarted {...partnerProps} />
    <h4 {...{
      "id": "instructions"
    }}>{`Instructions`}</h4>
    <Partnership.AuthInstructions {...partnerProps} />
    <Partnership.Server {...partnerProps} />
    <h4 {...{
      "id": "launching-to-production"
    }}>{`Launching to Production`}</h4>
    <Partnership.Conclusion {...partnerProps} />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "overview",
        level: 4,
        title: "Overview",
      },
{
        id: "getting-started",
        level: 4,
        title: "Getting Started",
      },
{
        id: "instructions",
        level: 4,
        title: "Instructions",
      },
{
        id: "launching-to-production",
        level: 4,
        title: "Launching to Production",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
